var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "efdff294-d8e7-4f05-bc90-750403682bbb",
    "data-name": "Transparent Bounding Box (Export)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "aac3d3ec-907e-4e0d-9523-4232ecd3c1de",
    "data-name": "Icon Design (Export)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eecc6742-0176-456d-a10c-399f498e2e0b",
    "data-name": "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.43,13a8.4,8.4,0,0,0,.07-1,8.4,8.4,0,0,0-.07-1l2.11-1.65a.51.51,0,0,0,.12-.64l-2-3.46A.5.5,0,0,0,19.05,5L16.56,6a7.38,7.38,0,0,0-1.69-1l-.38-2.65A.48.48,0,0,0,14,2H10a.5.5,0,0,0-.49.42L9.13,5.07a8,8,0,0,0-1.69,1L5,5.05a.49.49,0,0,0-.61.22l-2,3.46a.48.48,0,0,0,.12.64L4.57,11a8.4,8.4,0,0,0-.07,1,8.4,8.4,0,0,0,.07,1L2.46,14.63a.51.51,0,0,0-.12.64l2,3.46A.5.5,0,0,0,5,19l2.49-1a7.38,7.38,0,0,0,1.69,1l.38,2.65A.49.49,0,0,0,10,22h4a.5.5,0,0,0,.49-.42l.38-2.65a8,8,0,0,0,1.69-1l2.49,1a.49.49,0,0,0,.61-.22l2-3.46a.51.51,0,0,0-.12-.64ZM12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z",
    fill: "#000001"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.40a16304cb03902f9b25438e8d3b38f4.svg";
export { ForwardRef as ReactComponent };